import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    IconButton,
    Typography
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

const MultiSelectDialog = ({
    open,
    onClose,
    options,
    selected,
    onChange,
    title
}) => {

    const toggleValue = (value) => {

        if (selected.includes(value)) {

            onChange(
                selected.filter(item => item !== value)
            );

        } else {

            onChange([...selected, value]);
        }
    };

    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="xs"
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    overflow: "hidden"
                }
            }}
        >

            {/* HEADER */}

            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: "#002147",
                    color: "#fff",
                    py: 1.5,
                    px: 2
                }}
            >

                <Typography
                    sx={{
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        fontSize: "1rem"
                    }}
                >
                    {title}
                </Typography>

                <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{
                        color: "#fff"
                    }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>

            </DialogTitle>

            {/* CONTENT */}

            <DialogContent
                sx={{
                    pt: 2,
                    px: 2,
                    maxHeight: 400
                }}
            >

                <FormGroup>

                    {options.map(option => (

                        <FormControlLabel
                            key={option}
                            sx={{
                                borderRadius: 2,
                                px: 1,
                                py: 0.3,
                                mb: 0.5,
                                transition: "0.2s",
                                "&:hover": {
                                    backgroundColor: "#f5f7fa"
                                }
                            }}
                            control={
                                <Checkbox
                                    checked={selected.includes(option)}
                                    onChange={() => toggleValue(option)}
                                    sx={{
                                        color: "#002147",
                                        "&.Mui-checked": {
                                            color: "#002147"
                                        }
                                    }}
                                />
                            }
                            label={
                                <Typography
                                    sx={{
                                        fontFamily: "Poppins",
                                        fontSize: "0.95rem"
                                    }}
                                >
                                    {option}
                                </Typography>
                            }
                        />

                    ))}

                </FormGroup>

                {/* FOOTER */}

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mt: 3,
                        pt: 2,
                        borderTop: "1px solid #eee"
                    }}
                >

                    <Button
                        variant="contained"
                        onClick={onClose}
                        sx={{
                            backgroundColor: "#002147",
                            color: "#fff",
                            textTransform: "none",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            borderRadius: 1,
                            px: 3,
                            "&:hover": {
                                backgroundColor: "#00152e"
                            }
                        }}
                    >
                        Done
                    </Button>

                </Box>

            </DialogContent>

        </Dialog>
    );
};

export default MultiSelectDialog;